// Will be used during 2 phase for interaction user actions

interface State {
    message: string | null;
}

const initialState: State = {
    message: null,
};

export function successReducer(state = initialState, action) {
    switch (action.type) {
        default: {
            return state;
        }
    }
}
